import Link from "next/link";

export function SuspendedBanner() {
  return (
    <div className="bg-destructive text-destructive-foreground px-4 py-2 text-sm text-center">
      <span className="font-medium">Your workspace is suspended.</span> Alerts are not being sent,
      and your public status pages show a billing notice. Your monitors are still running and no
      data has been deleted.{" "}
      <Link href="/dashboard/billing" className="underline font-medium">
        Reactivate
      </Link>{" "}
      or{" "}
      <Link href="/dashboard/settings" className="underline font-medium">
        delete your workspace
      </Link>
      .
    </div>
  );
}
